import { TRAINING_APP_PATH } from 'modules/training/modules/app/constants'
import { getObjectUtil } from 'packages/src'

const isCheckingAndroidAppSelect = state => {
  return !!getObjectUtil(state, TRAINING_APP_PATH.IS_CHECKING_ANDROID)
}

export default isCheckingAndroidAppSelect
